import { useEffect, useState } from "react";
import Button from "../../../../components/Button/Button";
import styles from "./EntityRequest.module.css";

import { ArrowBack, Edit } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";

import Documents from "./Documents";
import FormSupplier from "./FormSupplier";
import IncomingPayments from "./IncomingPayments";

const EntitySupplier = () => {
  const { uid } = useParams();

  const [dropDown, setDropDown] = useState("");

  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState<{
    uid?: string;
    isEdit?: boolean;
  }>({
    uid: "",
    isEdit: !uid,
  });

  const handleVisible = (fieldName: string, uid: string, e: boolean) => {
    setIsVisible((prev) => ({
      ...prev,
      [fieldName]: e,
      uid,
    }));
  };

  useEffect(() => {
    if (uid) {
      setIsVisible({ isEdit: false });
    }
  }, [uid]);

  const handleDropDown = (id: string) => {
    let value = id;
    if (dropDown === value) {
      value = "";
    }
    setDropDown(value);
  };

  return (
    <div className={styles.containerRequests}>
      <div className={styles.requests}>
        <div className={styles.headerAdd}>
          <div className={styles.header}>
            <h1>Cadastro de Fornecedor</h1>
            <div className={styles.headerButtons}>
              {uid && (
                <>
                  <Button
                    variant="contain"
                    title="Editar pedido"
                    type="button"
                    onClick={() =>
                      handleVisible("isEdit", "", !isVisible.isEdit)
                    }
                  >
                    <Edit />
                  </Button>
                </>
              )}
              <Button
                variant="contain"
                type="button"
                title="Voltar para página anterior"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBack />
              </Button>
            </div>
          </div>
        </div>

        <div className={styles.containerDate}>
          <div className={styles.headerDate}>
            <h2>DADOS DO FORNECEDOR</h2>
          </div>
          <div className={styles.formDate}>
            <FormSupplier
              uid={uid}
              isEdit={isVisible.isEdit}
              handleVisible={handleVisible}
            />
          </div>
        </div>
        <div className={styles.containerSections}>
          <div className={styles.containerDate}>
            <div
              className={styles.headerDate}
              onClick={() => handleDropDown("PAYMENTS")}
            >
              <h2>CONTAS A PAGAR</h2>
            </div>
            {dropDown === "PAYMENTS" && (
              <div className={styles.formDate}>
                <IncomingPayments uid_fornecedor={uid!} />
              </div>
            )}
          </div>
          <div className={styles.containerDate}>
            <Documents uid_compra={uid} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntitySupplier;
